import './ui.css'
import { FlowMark } from './icons.jsx'

/* Screen shell: fixed wordmark header + calm body. */
export function Screen({ children, right = null, headerDelay = 0 }) {
  return (
    <div className="screen">
      <header className="screen__header">
        <span className="wordmark rise" style={delay(headerDelay)}>
          <FlowMark /> Flow
        </span>
        {right}
      </header>
      <div className="screen__body">{children}</div>
    </div>
  )
}

/* Edge-lit glass panel (Design System v1.0 — layer 3). */
export function Panel({ children, className = '', as: Tag = 'div', ...rest }) {
  return <Tag className={`panel ${className}`} {...rest}>{children}</Tag>
}

/* Hero icon lens — smoked glass, soft glow, never a hard-edged ring. */
export function HeroLens({ children, size = 64, tone = 'accent' }) {
  return (
    <span className={`hero-lens hero-lens--${tone}`} style={{ width: size, height: size }}>
      {children}
    </span>
  )
}

export function PrimaryButton({ children, className = '', ...rest }) {
  return <button className={`btn btn--primary ${className}`} {...rest}>{children}</button>
}

export function SecondaryButton({ children, className = '', ...rest }) {
  return <button className={`btn btn--secondary ${className}`} {...rest}>{children}</button>
}

export function GhostButton({ children, className = '', ...rest }) {
  return <button className={`btn btn--ghost ${className}`} {...rest}>{children}</button>
}

/* Visible DEMO tag — shown whenever demo/fixture data is the active source, so
 * sample content is never mistaken for real (Design System v1.0). */
export function DemoTag() {
  return <span className="demo-tag" title="Sample data — backend not connected">DEMO DATA</span>
}

/* Offline chip — Capture-class never blocks; this is quiet, non-alarming. */
export function OfflineChip({ children }) {
  return <span className="offline-chip">{children}</span>
}

function delay(ms) {
  return ms ? { animationDelay: `${ms}ms` } : undefined
}
